import React from 'react';
import CheckoutContainer from '../components/checkout.container';

const CheckoutPage: React.FC = () => {
  return (
    <div className="h-full overflow-y-auto bg-gray-900 px-4 py-8">
      <CheckoutContainer />
    </div>
  );
};

export default CheckoutPage;
